import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Loader from './include/Loader';
import Header from './include/Header';
import Footer from './include/Footer';

import Signup from './include/Signup';
import Login from './include/Login';
import Otpcheck from './include/Otpcheck';
import ResetPassword from './include/ResetPassword';
import NewPassword from './include/NewPassword';

import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import parse from "html-react-parser";

const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo({ behavior: 'smooth', top: 0 })

        getCMSData();
    }, [])

    const [disable, setDisable] = useState(false);
    const [errors, setErrors] = useState({});
    const [cms, setCMS] = useState("");

    const getCMSData = (e) => {

        const myurl = "https://events.teambuildingawards.com:3000/api/web/get-cms";
        var bodyFormData = new URLSearchParams();
        bodyFormData.append('cms', 'refresh');
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((response) => {
            //console.log("AF",response?.data?.data);
            setCMS(parse(response?.data?.data?.privacy_policy));

        }).catch((error) => {
            console.log("Errors", error);
            setDisable(false);
        })

    }

    return (
        <>
            <Header />

            <main className="tba-site-content">


                <section className="tba-inner-landing-section">
                    <div className="tba-inner-landing-img">
                        <img src="/assets/images/inner-landing-img.png" alt="inner-landing-img" className="img-fluid w-100" />
                    </div>
                    <div className="tba-inner-landing-content">
                        <div className="container">
                            <h1 className="tba-section-title">Privacy Policy</h1>
                        </div>
                    </div>
                </section>

                <section className="tba-mission-section">
                    <div className="container">
                        <div className="row">
                            <div className="col col-12 col-md-12 col-lg-12">
                                {cms}
                            </div>

                        </div>
                    </div>
                </section>


            </main>
            <Signup />
            <Login />
            <Otpcheck />
            <ResetPassword />
            <NewPassword />
            <Footer />
        </>
    )
}

export default PrivacyPolicy